/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_Errors_DescInputs */

const en_privacy_section_6_errors_desc = /** @type {(inputs: Privacy_Section_6_Errors_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retained in Sentry for 90 days`)
};

const lv_privacy_section_6_errors_desc = /** @type {(inputs: Privacy_Section_6_Errors_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`saglabāti Sentry 90 dienas`)
};

/**
* | output |
* | --- |
* | "retained in Sentry for 90 days" |
*
* @param {Privacy_Section_6_Errors_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_errors_desc = /** @type {((inputs?: Privacy_Section_6_Errors_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_Errors_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_errors_desc(inputs)
	return en_privacy_section_6_errors_desc(inputs)
});